export const ADJUST_BY_TOOLTIP =
  "Adjusts each method's current value by the specified amount. For example, +$25 adds $25 and -$25 subtracts $25 from each method's existing value.";

export const BULK_EDIT_API_ENDPOINT = '/admin/v1/shippings/bulk-edit';

export const BULK_EDIT_MODES = {
  NAME_DESCRIPTION: 'name-description',
  SHIPPING_THRESHOLDS: 'shipping-thresholds',
  SHIPPING_RATES: 'shipping-rates',
  SHIP_TO: 'ship-to',
  DISPLAY_CONDITIONS: 'display-conditions',
  MOVE_TO_SECTION: 'move-to-section',
} as const;

export const DISPLAY_CONDITIONS_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove',
  APPEND_TO_ALL: 'append-to-all',
} as const;

export const SHIP_TO_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove',
} as const;

export const NOTE_ACTIONS = {
  CHANGE: 'change',
  REMOVE: 'remove',
} as const;
